// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DemandApprovalPage {

    height: 90vh;
    overflow-x: hidden;
    overflow-y: scroll;
    scroll-behavior: smooth;

    .DemandElement {
        width: 100%;
        /* box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274); */
        border-radius: 5px;
        padding: 20px 50px;
        background-color: white;

        label {
            font-size: 16px;
            font-weight: 500;
        }


        .elements {
            margin: 15px 0px;

            .part1 {
                font-size: 14px;
                border: 1px solid black;
            }


            .labelContianer {
                width: fit-content;

                label {
                    font-size: 14px;
                }
            }
        }


        textarea,
        select,
        input {
            width: 100%;
            border: 1px solid #505050;
            padding: 5px 10px;
            font-size: 16px;
            font-weight: 400;
            border-radius: 3px;
        }

        select {
            font-size: 14px !important;
            font-weight: 500 !important;
            color: #817f7f;
        }

        select:focus {
            color: black;
        }

        textarea {
            height: 12vh;
        }

        ::placeholder {
            color: #817f7f;
        }
    }

    .shadowbox {
        box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274);
        border-radius: 5px;
        padding: 25px 15px;
        background-color: white;
    }



    .tableContainer {
        table {
            width: 100%;
            border: 1px solid #000000;
            border-collapse: 'collapse';
            text-align: 'center';
            border: '1px solid #1976d2';


            tr,
            th,
            td {
                padding: 10px;
                font-size: 1px;
            }

            tr,
            th,
            td {
                border: 1px solid #000000 !important;
                font-size: 16px;

            }

            thead {
                tr {
                    background-color: #0094DE;
                    color: white;

                    th {
                        font-weight: 500 !important;
                    }
                }
            }

            tbody {
                tr {
                    /* border: 1px solid #000000 !important; */

                    td {
                        /* border: 1px solid #000000 !important; */
                        font-weight: 400 !important;
                    }

                }
            }

        }
    }

    .tableContainer1 {
        width: 100%;

        table {
            width: 100%;
            border: 1px solid #000000;


            tr,
            th,
            td {
                padding: 10px 0px;
            }

            tr,
            th,
            td {
                border: 1px solid #000000 !important;
                font-size: 10px;

            }

            thead {
                tr {
                    background-color: #0094DE;
                    color: white;

                    th {
                        font-weight: 500 !important;
                    }
                }
            }

            tbody {
                tr {
                    /* border: 1px solid #000000 !important; */

                    td {
                        /* border: 1px solid #000000 !important; */
                        font-weight: 400 !important;
                    }

                }
            }

        }
    }

    .tableContainer2 {
        width: 100%;
        overflow-x: auto;
        border-radius: 8px;
        background-color: white;
        border: 1px solid #1976d2;

        table {
            width: 100%;
            border-collapse: collapse;

            thead {
                tr {
                    th {
                        font-weight: 500;
                    }
                }
            }

            tbody {
                tr {
                    background-color: #E0E6F4;

                    td {
                        font-weight: 400;
                    }
                }
            }

        }
    }
}


.makeitlink {
    color: #4f46e5;
    text-decoration: underline;
    font-weight: 700;
    cursor: pointer;
}

.DistrictTableContianer {
    width: 80%;
    box-shadow: 0 4px 12px rgba(78, 70, 229, 0.192);

    table {
        width: 100%;
        border-radius: 8;

        thead {

            th {
                padding: 10px 8px;
                background-color: #4f46e5;
                color: white;
                font-weight: 600;
                font-size: 15px;
                -webkit-user-select: none;
                        user-select: none;
            }
        }

        tbody {
            tr {
                td {

                    /* border: 1px solid #4f46e5 !important; */
                    padding: 12px 10px;
                    font-size: 14px;
                    color: #333
                }
            }
        }

    }
}`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/ECSGeneration/ECSGeneration.css"],"names":[],"mappings":"AAAA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;;IAEvB;QACI,WAAW;QACX,sDAAsD;QACtD,kBAAkB;QAClB,kBAAkB;QAClB,uBAAuB;;QAEvB;YACI,eAAe;YACf,gBAAgB;QACpB;;;QAGA;YACI,gBAAgB;;YAEhB;gBACI,eAAe;gBACf,uBAAuB;YAC3B;;;YAGA;gBACI,kBAAkB;;gBAElB;oBACI,eAAe;gBACnB;YACJ;QACJ;;;QAGA;;;YAGI,WAAW;YACX,yBAAyB;YACzB,iBAAiB;YACjB,eAAe;YACf,gBAAgB;YAChB,kBAAkB;QACtB;;QAEA;YACI,0BAA0B;YAC1B,2BAA2B;YAC3B,cAAc;QAClB;;QAEA;YACI,YAAY;QAChB;;QAEA;YACI,YAAY;QAChB;;QAEA;YACI,cAAc;QAClB;IACJ;;IAEA;QACI,gDAAgD;QAChD,kBAAkB;QAClB,kBAAkB;QAClB,uBAAuB;IAC3B;;;;IAIA;QACI;YACI,WAAW;YACX,yBAAyB;YACzB,2BAA2B;YAC3B,oBAAoB;YACpB,2BAA2B;;;YAG3B;;;gBAGI,aAAa;gBACb,cAAc;YAClB;;YAEA;;;gBAGI,oCAAoC;gBACpC,eAAe;;YAEnB;;YAEA;gBACI;oBACI,yBAAyB;oBACzB,YAAY;;oBAEZ;wBACI,2BAA2B;oBAC/B;gBACJ;YACJ;;YAEA;gBACI;oBACI,0CAA0C;;oBAE1C;wBACI,0CAA0C;wBAC1C,2BAA2B;oBAC/B;;gBAEJ;YACJ;;QAEJ;IACJ;;IAEA;QACI,WAAW;;QAEX;YACI,WAAW;YACX,yBAAyB;;;YAGzB;;;gBAGI,iBAAiB;YACrB;;YAEA;;;gBAGI,oCAAoC;gBACpC,eAAe;;YAEnB;;YAEA;gBACI;oBACI,yBAAyB;oBACzB,YAAY;;oBAEZ;wBACI,2BAA2B;oBAC/B;gBACJ;YACJ;;YAEA;gBACI;oBACI,0CAA0C;;oBAE1C;wBACI,0CAA0C;wBAC1C,2BAA2B;oBAC/B;;gBAEJ;YACJ;;QAEJ;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,kBAAkB;QAClB,uBAAuB;QACvB,yBAAyB;;QAEzB;YACI,WAAW;YACX,yBAAyB;;YAEzB;gBACI;oBACI;wBACI,gBAAgB;oBACpB;gBACJ;YACJ;;YAEA;gBACI;oBACI,yBAAyB;;oBAEzB;wBACI,gBAAgB;oBACpB;gBACJ;YACJ;;QAEJ;IACJ;AACJ;;;AAGA;IACI,cAAc;IACd,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,+CAA+C;;IAE/C;QACI,WAAW;QACX,gBAAgB;;QAEhB;;YAEI;gBACI,iBAAiB;gBACjB,yBAAyB;gBACzB,YAAY;gBACZ,gBAAgB;gBAChB,eAAe;gBACf,yBAAiB;wBAAjB,iBAAiB;YACrB;QACJ;;QAEA;YACI;gBACI;;oBAEI,0CAA0C;oBAC1C,kBAAkB;oBAClB,eAAe;oBACf;gBACJ;YACJ;QACJ;;IAEJ;AACJ","sourcesContent":[".DemandApprovalPage {\r\n\r\n    height: 90vh;\r\n    overflow-x: hidden;\r\n    overflow-y: scroll;\r\n    scroll-behavior: smooth;\r\n\r\n    .DemandElement {\r\n        width: 100%;\r\n        /* box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274); */\r\n        border-radius: 5px;\r\n        padding: 20px 50px;\r\n        background-color: white;\r\n\r\n        label {\r\n            font-size: 16px;\r\n            font-weight: 500;\r\n        }\r\n\r\n\r\n        .elements {\r\n            margin: 15px 0px;\r\n\r\n            .part1 {\r\n                font-size: 14px;\r\n                border: 1px solid black;\r\n            }\r\n\r\n\r\n            .labelContianer {\r\n                width: fit-content;\r\n\r\n                label {\r\n                    font-size: 14px;\r\n                }\r\n            }\r\n        }\r\n\r\n\r\n        textarea,\r\n        select,\r\n        input {\r\n            width: 100%;\r\n            border: 1px solid #505050;\r\n            padding: 5px 10px;\r\n            font-size: 16px;\r\n            font-weight: 400;\r\n            border-radius: 3px;\r\n        }\r\n\r\n        select {\r\n            font-size: 14px !important;\r\n            font-weight: 500 !important;\r\n            color: #817f7f;\r\n        }\r\n\r\n        select:focus {\r\n            color: black;\r\n        }\r\n\r\n        textarea {\r\n            height: 12vh;\r\n        }\r\n\r\n        ::placeholder {\r\n            color: #817f7f;\r\n        }\r\n    }\r\n\r\n    .shadowbox {\r\n        box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274);\r\n        border-radius: 5px;\r\n        padding: 25px 15px;\r\n        background-color: white;\r\n    }\r\n\r\n\r\n\r\n    .tableContainer {\r\n        table {\r\n            width: 100%;\r\n            border: 1px solid #000000;\r\n            border-collapse: 'collapse';\r\n            text-align: 'center';\r\n            border: '1px solid #1976d2';\r\n\r\n\r\n            tr,\r\n            th,\r\n            td {\r\n                padding: 10px;\r\n                font-size: 1px;\r\n            }\r\n\r\n            tr,\r\n            th,\r\n            td {\r\n                border: 1px solid #000000 !important;\r\n                font-size: 16px;\r\n\r\n            }\r\n\r\n            thead {\r\n                tr {\r\n                    background-color: #0094DE;\r\n                    color: white;\r\n\r\n                    th {\r\n                        font-weight: 500 !important;\r\n                    }\r\n                }\r\n            }\r\n\r\n            tbody {\r\n                tr {\r\n                    /* border: 1px solid #000000 !important; */\r\n\r\n                    td {\r\n                        /* border: 1px solid #000000 !important; */\r\n                        font-weight: 400 !important;\r\n                    }\r\n\r\n                }\r\n            }\r\n\r\n        }\r\n    }\r\n\r\n    .tableContainer1 {\r\n        width: 100%;\r\n\r\n        table {\r\n            width: 100%;\r\n            border: 1px solid #000000;\r\n\r\n\r\n            tr,\r\n            th,\r\n            td {\r\n                padding: 10px 0px;\r\n            }\r\n\r\n            tr,\r\n            th,\r\n            td {\r\n                border: 1px solid #000000 !important;\r\n                font-size: 10px;\r\n\r\n            }\r\n\r\n            thead {\r\n                tr {\r\n                    background-color: #0094DE;\r\n                    color: white;\r\n\r\n                    th {\r\n                        font-weight: 500 !important;\r\n                    }\r\n                }\r\n            }\r\n\r\n            tbody {\r\n                tr {\r\n                    /* border: 1px solid #000000 !important; */\r\n\r\n                    td {\r\n                        /* border: 1px solid #000000 !important; */\r\n                        font-weight: 400 !important;\r\n                    }\r\n\r\n                }\r\n            }\r\n\r\n        }\r\n    }\r\n\r\n    .tableContainer2 {\r\n        width: 100%;\r\n        overflow-x: auto;\r\n        border-radius: 8px;\r\n        background-color: white;\r\n        border: 1px solid #1976d2;\r\n\r\n        table {\r\n            width: 100%;\r\n            border-collapse: collapse;\r\n\r\n            thead {\r\n                tr {\r\n                    th {\r\n                        font-weight: 500;\r\n                    }\r\n                }\r\n            }\r\n\r\n            tbody {\r\n                tr {\r\n                    background-color: #E0E6F4;\r\n\r\n                    td {\r\n                        font-weight: 400;\r\n                    }\r\n                }\r\n            }\r\n\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.makeitlink {\r\n    color: #4f46e5;\r\n    text-decoration: underline;\r\n    font-weight: 700;\r\n    cursor: pointer;\r\n}\r\n\r\n.DistrictTableContianer {\r\n    width: 80%;\r\n    box-shadow: 0 4px 12px rgba(78, 70, 229, 0.192);\r\n\r\n    table {\r\n        width: 100%;\r\n        border-radius: 8;\r\n\r\n        thead {\r\n\r\n            th {\r\n                padding: 10px 8px;\r\n                background-color: #4f46e5;\r\n                color: white;\r\n                font-weight: 600;\r\n                font-size: 15px;\r\n                user-select: none;\r\n            }\r\n        }\r\n\r\n        tbody {\r\n            tr {\r\n                td {\r\n\r\n                    /* border: 1px solid #4f46e5 !important; */\r\n                    padding: 12px 10px;\r\n                    font-size: 14px;\r\n                    color: #333\r\n                }\r\n            }\r\n        }\r\n\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
